import { AbstractMediaData, AbstractMediaSchema } from ".";
import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";

export interface AbstractTypeMediaData {
    description?: string;
    id: number;
    index: number;
    label: string;
    labelHint?: string;
    maxUploads?: number;
    maxSize: number;
    minUploads?: number;
    media: AbstractMediaData[];
    mediaType: string;
    mediaTypeExtns: string;
    mediaTypeId: number;
    promptCaption: boolean;
    promptKeywords: boolean;
    promptTitle: boolean;
    requiredAfterAccept: boolean;
    requiredForSubmit: boolean;
}

export class AbstractTypeMedia implements FormValidationModel<AbstractTypeMediaData> {
    public data: AbstractTypeMediaData;
    public rules: yup.Schema<AbstractTypeMediaData>;

    public constructor() {
        this.data = {
            id: 0,
            index: 0,
            label: "",
            maxSize: 0,
            media: [],
            mediaType: "",
            mediaTypeExtns: "",
            mediaTypeId: 0,
            promptCaption: false,
            promptKeywords: false,
            promptTitle: false,
            requiredAfterAccept: false,
            requiredForSubmit: false,
        };
        this.rules = yup.object<AbstractTypeMediaData>().shape({
            description: yup.string().nullable(true),
            id: yup.number(),
            index: yup.number(),
            label: yup.string().nullable(true),
            labelHint: yup.string().nullable(true),
            maxUploads: yup.number().nullable(true),
            maxSize: yup.number().nullable(true),
            minUploads: yup.number().nullable(true),
            media: yup.array().of(AbstractMediaSchema).when(["label"], (label: string) => yup.array().of(AbstractMediaSchema).label(label)),
            mediaType: yup.string().nullable(true),
            mediaTypeExtns: yup.string().nullable(true),
            mediaTypeId: yup.number(),
            promptCaption: yup.bool(),
            promptKeywords: yup.bool(),
            promptTitle: yup.bool(),
            requiredAfterAccept: yup.bool(),
            requiredForSubmit: yup.bool(),
        });
    }
}

export const AbstractTypeMediaSchema = new AbstractTypeMedia().rules;



// WEBPACK FOOTER //
// ./src/forms/abstract/AbstractTypeMedia.ts